import styled from 'styled-components';
import {
  ToggleInput, ToggleButtonProps, ToggleButtonIconWrapperChecked, ToggleButtonIconWrapperUnchecked, ToggleButtonIconWrapperBase,
} from './ToggleInput';
import { useFormConfigurationContext } from '../FormConfigurationProvider';

const TripleToggleButtonIconWrapper = styled(ToggleButtonIconWrapperBase)<{checked?: boolean}>`${({ theme, checked }) => `
  ${(checked === undefined || checked === null) && `
    margin:auto;
  `}
  ${(checked === true) && ToggleButtonIconWrapperChecked(theme)}
  ${(checked === false) && ToggleButtonIconWrapperUnchecked(theme)}
`}`;

export type TripleToggleButtonProps =
  ToggleButtonProps
  & {
    firstClickValue?: boolean
  }

export function TripleToggleInput(props: TripleToggleButtonProps) {
  const {
    value, disabled, onChange, firstClickValue = true,
  } = props;

  const { isDisabled } = useFormConfigurationContext(disabled);

  const onClick = () => {
    if (!isDisabled) onChange(value !== null && value !== undefined ? !value : firstClickValue);
  };

  return (
    <ToggleInput {...props} onClickOverride={onClick} IconWrapper={TripleToggleButtonIconWrapper} />
  );
}
